// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Avatar_wrapper__gP2Q8","image":"Avatar_image__CHFHM"};